import './gameinsighticon.css'

import React from "react"
import { IonIcon } from "@ionic/react"
import { gitCompareOutline } from "ionicons/icons"

const GameInsightIcon = (props: {
    slot?: string
}) => (
    <IonIcon icon={gitCompareOutline} className="game-insight-icon" slot={props.slot} />
)

export default GameInsightIcon
